var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_41381)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5462 8.13189C15.0181 8.0452 15.5041 8 16 8C20.4183 8 24 11.5817 24 16C24 20.4183 20.4183 24 16 24C15.5041 24 15.0181 23.9548 14.5462 23.8681C14.1841 23.8016 13.9445 23.4541 14.011 23.092C14.0775 22.7299 14.425 22.4902 14.7871 22.5567C15.1799 22.6289 15.5853 22.6667 16 22.6667C19.6819 22.6667 22.6667 19.6819 22.6667 16C22.6667 12.3181 19.6819 9.33333 16 9.33333C15.5853 9.33333 15.1799 9.37113 14.7871 9.44328C14.425 9.5098 14.0775 9.27016 14.011 8.90803C13.9445 8.54589 14.1841 8.19841 14.5462 8.13189ZM12.9104 9.31392C13.0948 9.63263 12.9859 10.0404 12.6672 10.2248C11.7577 10.7509 10.9837 11.4859 10.4111 12.3641C10.21 12.6725 9.79693 12.7595 9.48851 12.5584C9.18008 12.3574 9.09308 11.9443 9.29417 11.6359C9.98072 10.5829 10.9085 9.70179 11.9995 9.07067C12.3182 8.8863 12.726 8.99521 12.9104 9.31392ZM19.7913 13.5155C20.0589 13.7684 20.0707 14.1903 19.8179 14.4579L15.5291 18.9955C15.1033 19.4459 14.3966 19.4459 13.9709 18.9955L12.1822 17.103C11.9293 16.8354 11.9412 16.4135 12.2087 16.1605C12.4763 15.9077 12.8983 15.9195 13.1512 16.1871L14.75 17.8787L18.8488 13.5421C19.1017 13.2745 19.5237 13.2626 19.7913 13.5155ZM9.0078 13.684C9.36643 13.7673 9.5896 14.1256 9.50625 14.4842C9.39323 14.9705 9.33333 15.4779 9.33333 16C9.33333 16.5221 9.39323 17.0295 9.50625 17.5157C9.5896 17.8744 9.36643 18.2327 9.0078 18.316C8.64917 18.3994 8.29088 18.1762 8.20753 17.8176C8.07167 17.233 8 16.6245 8 16C8 15.3755 8.07167 14.767 8.20753 14.1824C8.29088 13.8238 8.64917 13.6006 9.0078 13.684ZM9.48851 19.4415C9.79693 19.2405 10.21 19.3275 10.4111 19.6359C10.9837 20.5141 11.7577 21.2491 12.6672 21.7752C12.9859 21.9595 13.0948 22.3674 12.9104 22.6861C12.726 23.0048 12.3182 23.1137 11.9995 22.9293C10.9085 22.2982 9.98072 21.4171 9.29417 20.3641C9.09308 20.0557 9.18008 19.6427 9.48851 19.4415Z",
    fill: "#FAB732"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_41381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.49a60e997aad51ac6535ae31706785a0.svg";
export { ForwardRef as ReactComponent };